<div class="card collapse-icon accordion-icon-rotate mb-1" style="margin-bottom: 1rem">
  <div
    [id]="nomeComponente + 'Collapse'"
    class="card-header collapse-format"
    [ngClass]="camposInvalidos === false ? 'border-info' : 'border-danger'">
    <a
      style="cursor: pointer; display: flex; align-items: center; justify-content: space-between; width: 100%"
      [attr.aria-expanded]="estaAberto"
      [attr.aria-controls]="'collapse' + nomeComponente"
      class="card-title lead info cursor-pointer"
      [ngClass]="camposInvalidos === false ? 'info' : 'danger'"
      (click)="alternarAccordion()">
      <div>
        <i [class]="iconeAccordion" aria-hidden="true"></i>
        {{ tituloAccordion }}
        <i
          *ngIf="camposInvalidos"
          style="color: red"
          placement="top"
          ngbTooltip="Verifique os campos obrigatórios."
          class="cursor-pointer fa fa-exclamation-triangle"
          aria-hidden="true"></i>
      </div>
      <svg class="icone-alternar-estado-accordion" [class.aberto]="estaAberto" viewBox="0 0 24 24" aria-hidden="true">
        <line class="linha-horizontal" x1="5" y1="12" x2="19" y2="12" />
        <line class="linha-vertical" x1="12" y1="5" x2="12" y2="19" />
      </svg>
    </a>
  </div>
  <div
    [id]="'collapse' + nomeComponente"
    role="tabpanel"
    [attr.aria-labelledby]="'headingCollapse' + nomeComponente"
    class="card-collapse collapse"
    [ngbCollapse]="!estaAberto">
    <div class="card-content">
      <div class="card-body">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
